import {
  EnrichmentRequest,
  EnrichmentResponse,
  EnrichmentTemplate
} from '@/types/enrichment'
import BaseService from './baseService'
import EndPoints from '@/constants/dxApiEndpoints'

class EnrichmentService extends BaseService {
  GetEnrichedData = async (
    businessProfileId: number,
    requestData: EnrichmentRequest
  ): Promise<EnrichmentResponse[]> => {
    const response = await this.apiClient.post<{ data: EnrichmentResponse[] }>(
      EndPoints.ProductEnrichment(businessProfileId),
      requestData
    )
    return response.data
  }

  GetEnrichmentTemplates = async (
    businessProfileId: number
  ): Promise<EnrichmentTemplate[]> => {
    const response = await this.apiClient.get<{ data: EnrichmentTemplate[] }>(
      EndPoints.EnrichmentTemplates(businessProfileId)
    )
    return response.data
  }
}

export default EnrichmentService
